import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import logo from '../../../../assets/images/logo.png'
import styles from '../footer.module.css'
import FbIcon from '../../../../assets/images/homepage/FbIcon.svg'
import TwitterIcon from '../../../../assets/images/homepage/xIcon.svg'
import InstaIcon from '../../../../assets/images/homepage/InstaIcon.svg'
import LinkdIcon from '../../../../assets/images/homepage/LinkdIcon.svg'
import GitIcon from '../../../../assets/images/homepage/GitIcon.svg'
import GoogleMarket from '../../../../assets/images/homepage/GoogleMarketPlace.svg'
import AppleMarket from '../../../../assets/images/homepage/AppleMarketPlace.svg'

const MainFooter = () => {
    return (
        <section className={`${styles['footer-bg']}`}>
            <div className={`${styles['footer-innerbg']}`}>
                <div className='container'>
                    <div className='row mb-5'>
                        <div className={`${styles['m-center']} col-md`}>
                            <div className={`${styles['mmb-20']} logo`}>
                                <Link to='/'><img src={logo} alt="logo" /></Link>
                            </div>
                            <p className={`${styles['ft-text']} ${styles['mmb-20']}`}>Connecting college students with internships & entry-level jobs. Discover opportunities, resources, & a network to start your career. Empower your future with us.</p>
                        </div>
                        <div className='col-md-2'>
                            <h6 className={`${styles['footer-title']}`}>Recruitment Solutions</h6>
                            <ul className={`${styles['footer-list']} ${styles['mmb-20']}`}>
                                <li><a href='#'>Job Posting</a></li>
                                <li><a href='https://jobzshalarecruit.com'>CRM</a></li>
                                <li><a href='#'>Corporate Training</a></li>
                                <li><a href='https://campus.jobzshala.com/'>Campus Hiring</a></li>
                            </ul>
                        </div>
                        <div className='col-md-2'>
                            <h6 className={`${styles['footer-title']}`}>Information</h6>
                            <ul className={`${styles['footer-list']} ${styles['mmb-20']}`}>
                                <li><a href='https://jobzshala.com/about-us'>About Us</a></li>
                                <li><a href='https://jobzshala.com/blogs'>Blog</a></li>
                                <li><a href='https://jobzshala.com'>Jobseeker Home</a></li>
                                <li><a href='#'>FAQs</a></li>
                            </ul>
                        </div>
                        <div className='col-md-2'>
                            <h6 className={`${styles['footer-title']}`}>Legal</h6>
                            <ul className={`${styles['footer-list']} ${styles['mmb-20']}`}>
                                <li><a href='https://jobzshala.com/privacy-policy'>Privacy Policy</a></li>
                                <li><a href='https://jobzshala.com/termsconditions'>User Terms & Conditions</a></li>
                                <li><a href='#'>Employer Terms of Service</a></li>
                                <li><a href='#'>Community Guidelines</a></li>
                            </ul>
                        </div>
                        <div className='col-md'>
                            <div className={`${styles['footer-box']} text-center`}>
                                <h5>JobzShala Mobile App is Now Live! 🚀</h5>
                                <p>Experience the future of hiring and job searching at your fingertips.</p>
                                <div>
                                    <a href='https://play.google.com/store/apps/details?id=com.jobzshala.app&hl=en' target='_blank'><img src={GoogleMarket} alt="Download on Google Play" /></a>
                                    <a href='https://apps.apple.com/in/app/jobzshala-mobile-app/id6740089211' target='_blank'><img src={AppleMarket} alt="Download on App Store" /></a>
                                </div>
                            </div>
                        </div>

                    </div>
                    <hr />
                    <div className='row mt-4'>
                        <div className='col-md-6'>
                            <h5 className={`${styles['copyright-text']}`}>© Copyright 2024, All Rights Reserved by JobzShala</h5>
                        </div>
                        <div className='col-md-6 text-end'>
                            <ul className={`${styles['footer-social']}`}>
                                <li><a href='#'><img src={FbIcon} /></a></li>
                                <li><a href='#'><img src={TwitterIcon} /></a></li>
                                <li><a href='#'><img src={InstaIcon} /></a></li>
                                <li><a href='#'><img src={GitIcon} /></a></li>
                                <li><a href='#'><img src={LinkdIcon} /></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MainFooter